{
  "$schema": "https://mux.run/theme.json",
  "name": "Vercel",
  "id": "vercel",
  "light": {
    "palette": {
      "neutral": "#FFFFFF",
      "ink": "#171717",
      "primary": "#0070F3",
      "accent": "#8E4EC6",
      "success": "#388E3C",
      "warning": "#FF9500",
      "error": "#DC3545",
      "info": "#0070F3",
      "diffAdd": "#46A758",
      "diffDelete": "#E5484D"
    },
    "overrides": {
      "text-weak": "#666666",
      "syntax-comment": "#888888",
      "syntax-keyword": "#E93D82",
      "syntax-string": "#46A758",
      "syntax-primitive": "#8E4EC6",
      "syntax-variable": "#0070F3",
      "syntax-property": "#12A594",
      "syntax-type": "#12A594",
      "syntax-constant": "#FFB224",
      "syntax-operator": "#E93D82",
      "syntax-punctuation": "#171717",
      "syntax-object": "#0070F3",
      "markdown-heading": "#8E4EC6",
      "markdown-text": "#171717",
      "markdown-link": "#0070F3",
      "markdown-link-text": "#12A594",
      "markdown-code": "#46A758",
      "markdown-block-quote": "#666666",
      "markdown-emph": "#FFB224",
      "markdown-strong": "#E93D82",
      "markdown-horizontal-rule": "#999999",
      "markdown-list-item": "#171717",
      "markdown-list-enumeration": "#0070F3",
      "markdown-image": "#12A594",
      "markdown-image-text": "#12A594",
      "markdown-code-block": "#171717"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#000000",
      "ink": "#EDEDED",
      "primary": "#0070F3",
      "accent": "#8E4EC6",
      "success": "#46A758",
      "warning": "#FFB224",
      "error": "#E5484D",
      "info": "#52A8FF",
      "interactive": "#52A8FF",
      "diffAdd": "#63C46D",
      "diffDelete": "#FF6166"
    },
    "overrides": {
      "text-weak": "#878787",
      "syntax-comment": "#878787",
      "syntax-keyword": "#F75590",
      "syntax-string": "#63C46D",
      "syntax-primitive": "#BF7AF0",
      "syntax-variable": "#52A8FF",
      "syntax-property": "#0AC7AC",
      "syntax-type": "#0AC7AC",
      "syntax-constant": "#F2A700",
      "syntax-operator": "#F75590",
      "syntax-punctuation": "#EDEDED",
      "syntax-object": "#52A8FF",
      "markdown-heading": "#BF7AF0",
      "markdown-text": "#EDEDED",
      "markdown-link": "#52A8FF",
      "markdown-link-text": "#0AC7AC",
      "markdown-code": "#63C46D",
      "markdown-block-quote": "#878787",
      "markdown-emph": "#F2A700",
      "markdown-strong": "#F75590",
      "markdown-horizontal-rule": "#454545",
      "markdown-list-item": "#EDEDED",
      "markdown-list-enumeration": "#52A8FF",
      "markdown-image": "#0AC7AC",
      "markdown-image-text": "#50E3C2",
      "markdown-code-block": "#EDEDED"
    }
  }
}
